<template>
  <el-row class="filter-row" v-show="geolocationIsPermitted && totalRegistros">
    <!--  Grupo de filtros  -->
    <el-badge
      :value="totalFiltersSelected"
      class="badge-filter"
      :hidden="false || totalFiltersSelected === 0"
    >
      <el-popover
        placement="bottom"
        width="200"
        trigger="click"
        class="filter-popover-select"
      >
        <slot>
          <div
            class="rede-credenciada-filter-content"
            v-for="(filter, idx) in filterOptions" :key="idx"
          >
            <div class="filter-group">
              <span class="filter-title">{{ filter.title }}</span>
              <ul class="filter-list">
                <el-radio-group
                  v-model="filter.value"
                  @change="onChangeFilterOrder"
                >
                  <li class="filter-item" v-for="item in filter.items" :key="item.value">
                    <el-radio :label="item.value">{{ item.description }}</el-radio>
                  </li>
                </el-radio-group>
              </ul>
            </div>
          </div>
        </slot>
        <el-button slot="reference" class="filter-button">
          Filtros <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-popover>
    </el-badge>

    <!--  Filtros  -->
    <el-badge
      :value="filter.value && filter.value.length ? 1 : 0"
      class="badge-filter"
      :hidden="filter.hideTotal"
      v-for="(filter, idx) in filterOptions" :key="idx"
    >
      <el-popover
        placement="bottom"
        width="200"
        trigger="click"
        class="filter-popover-select filter-spacing"
      >
        <slot>
          <div class="rede-credenciada-filter-content">
            <div class="filter-group">
              <span class="filter-title">{{ filter.internalTitle }}</span>
              <ul class="filter-list">
                <el-radio-group
                  v-model="filter.value"
                  @change="onChangeFilterOrder"
                >
                  <li class="filter-item" v-for="item in filter.items" :key="item.value">
                    <el-radio :label="item.value">{{ item.description }}</el-radio>
                  </li>
                </el-radio-group>
              </ul>
            </div>
          </div>
        </slot>
        <el-button slot="reference" class="filter-button">
          {{ filter.title }} <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-popover>
    </el-badge>
  </el-row>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import { EnumFiltros } from '@/constants/EnumsRedeCredenciada'

export default {
  name: 'Func4Filters',
  data () {
    return {
      filterOptions: [
        {
          type: 'ORDER',
          title: 'Ordenar por',
          internalTitle: 'Ordenar',
          hideTotal: true,
          items: [
            {
              description: 'Menor distância',
              value: EnumFiltros.ORDER_DIST
            },
            {
              description: 'Ordem alfabética (A-Z)',
              value: EnumFiltros.ORDER_ALFA
            }
          ],
          value: ''
        }
      ]
    }
  },
  computed: {
    ...mapState('RedeCredenciada', ['filtros']),
    ...mapGetters('RedeCredenciada', ['permiteGeolocalizacao', 'geolocalizacao', 'totalRegistros']),
    totalFiltersSelected () {
      let count = 0
      this.filterOptions.forEach(x => {
        if (x.value && x.value.length) count += 1
      })
      return count
    },
    geolocationIsPermitted () {
      return this.permiteGeolocalizacao && this.geolocalizacao.lat && this.geolocalizacao.lng
    }
  },
  methods: {
    onChangeFilterOrder (event) {
      this.$parent.$emit('changeFilters', { order: event })
    }
  },
  watch: {
    filtros (newValue) {
      if (newValue.order) {
        const index = this.filterOptions.findIndex(x => x.type === 'ORDER')
        this.filterOptions[index].value = newValue.order
      }
    }
  }
}
</script>

<style lang="less">

.filter-row {
  padding: 0 0 13px 13px;

  .badge-filter {
    .el-badge__content {
      background-color: var(--cor-secundaria-aplicacao);
    }
  }

  .filter-popover-select {
    .filter-button {
      border-radius: 20px;
      color: var(--cor-primaria-aplicacao);
      border-color: var(--cor-primaria-aplicacao);
      font-weight: 500;
      text-transform: none;
      font-size: 12px;
    }

    .filter-button:hover {
      background-color: var(--cor-primaria-aplicacao-semi-transparent);
    }
  }

  .filter-spacing {
    margin-left: 10px;
  }
}
.rede-credenciada-filter-content {
  .filter-group {
    padding: 10px;

    .filter-title {
      font-weight: 700;
    }

    .filter-list {
      padding-left: 0;
      list-style-type: none;

      .filter-item {
        height: 40px;

        .el-radio.is-checked span {
          color: var(--cor-primaria-aplicacao);

          .el-radio__inner {
            background-color: var(--cor-primaria-aplicacao);
            border-color: var(--cor-primaria-aplicacao);
          }
        }
      }
    }
  }
}

</style>
